import { definedValue } from '../index';
import { currencies } from '@dmm/lib-common/lib/currencies';
import { getCurrentCurrency } from '../language';

const HYPHEN = '-';
const COLON = ': ';
const SLASH = ' / ';
const PIPE = ' | ';
const COMMA = ', ';
const SEPARATORS = {
  HYPHEN,
  COLON,
  SLASH,
  PIPE,
  COMMA,
};

const PRICE_FORMATS = {
  NIL: '0',
  CODE_FIRST: '1',
  PREFIX: '2',
  SUFFIX: '3',
  BLANK: '4',
  NO_SEPARATOR: '5',
};

// We need this because formatting.js is of little help here and no point in updating the library.
const priceFormat = (amount, cur, options) => {
  if (!amount) {
    return PRICE_FORMATS.NIL;
  }
  const currency = definedValue(definedValue(options?.currency, currencies[cur]), currencies.USD);
  if (currency?.useCurrencyCode) {
    return PRICE_FORMATS.CODE_FIRST;
  }
  const symbolOrder = definedValue(options?.formatingOptions?.symbolOrder, '');
  if (symbolOrder === 'prefix') {
    return PRICE_FORMATS.PREFIX;
  }
  if (symbolOrder === 'postfix') {
    return PRICE_FORMATS.SUFFIX;
  }
  if (currency?.trailingSymbol) {
    return PRICE_FORMATS.BLANK;
  }
  return PRICE_FORMATS.NO_SEPARATOR;
};

const customCurrencySeparator = (options) => definedValue(options?.formatingOptions?.currencySeparator, '');

const parseFormattedPrice = (priceStr, formatType, customOptions) => {
  const options = customOptions || getCurrentCurrency();
  if (!priceStr) {
    return [0];
  }
  switch (formatType) {
    case PRICE_FORMATS.NIL:
      return [0];
    case PRICE_FORMATS.CODE_FIRST:
      return priceStr.split(' ');
    case PRICE_FORMATS.PREFIX:
      return priceStr.split(customCurrencySeparator(options)).reverse();
    case PRICE_FORMATS.SUFFIX:
      return priceStr.split(customCurrencySeparator(options));
    case PRICE_FORMATS.BLANK:
      return priceStr.split(' ');
    case PRICE_FORMATS.NO_SEPARATOR:
      return [priceStr];
    default:
      return [priceStr];
  }
};

const twoSplit = (str, sep = HYPHEN) => {
  const two = str?.split(sep);
  if (!two) {
    return [null, null];
  }
  if (!two[1]) {
    two[1] = two[0];
  }
  return [two[0], two[1]];
};

const parseFormattedNumber = (str) => {
  if (typeof str === 'number') {
    return str;
  }
  if (typeof str !== 'string') {
    return null;
  }
  const normalized = str.trim().replace(/\./g, '').replace(',', '.');
  const num = +normalized;
  return isNaN(num) ? null : num;
};

// example: Length: 250m / Width: 75m
const readProductDimensions = (str, splitter = SLASH) => {
  if (typeof str !== 'string') {
    throw new Error('readProductDimensionsString input must be a string');
  }
  const dimensions = str.split(splitter).map(part => {
    let [, dimension] = part.split(' ');
    return dimension;
  });
  return dimensions;
};

export { twoSplit, parseFormattedNumber, priceFormat, parseFormattedPrice, readProductDimensions, PRICE_FORMATS, SEPARATORS };
